export default { sha: 'aedf3ddd77c9da395c53e8a47c17f4ea5d08e0e1', buildNumber: 'undefined' }
